<template>
  <div class="about-page">
    <!-- Seção Hero -->
    <section class="hero-section">
      <div class="hero-content">
        <h1>AA.APP Desenvolvedores</h1>
        <p class="subtitle">Inovação com Integridade desde 2015</p>
        <p class="hero-description">
          Pioneiros em desenvolvimento móvel, transformamos ideias em experiências digitais excepcionais, 
          combinando excelência técnica com compromisso ético.
        </p>
      </div>
      <div class="hero-media">
        <img src="../assets/about-hero.png" alt="Equipe de desenvolvimento" class="hero-image">
      </div>
    </section>

    <!-- Nossa Jornada -->
    <section class="timeline-section">
      <h2 class="section-title">Nossa Trajetória</h2>
      <div class="timeline">
        <div class="timeline-item">
          <div class="timeline-year">2015</div>
          <div class="timeline-content">
            <h3>Fundação</h3>
            <p>Nascidos como startup em São Paulo com foco em soluções educacionais móveis</p>
          </div>
        </div>

        <div class="timeline-item">
          <div class="timeline-year">2018</div>
          <div class="timeline-content">
            <h3>Primeiro Milhão</h3>
            <p>Atingimos 1 milhão de usuários ativos em nossos aplicativos</p>
          </div>
        </div>

        <div class="timeline-item">
          <div class="timeline-year">2021</div>
          <div class="timeline-content">
            <h3>Certificação ISO 27001</h3>
            <p>Implementamos rigorosos padrões de segurança da informação</p>
          </div>
        </div>

        <div class="timeline-item">
          <div class="timeline-year">2024</div>
          <div class="timeline-content">
            <h3>Expansão Global</h3>
            <p>Atuação em 15 países com localização em 8 idiomas</p>
          </div>
        </div>
      </div>
    </section>

    <!-- Pilares Estratégicos -->
    <section class="pillars-section">
      <h2 class="section-title">Nossos Compromissos</h2>
      <div class="pillars-grid">
        <div class="pillar-card">
          <div class="pillar-icon">🛡️</div>
          <h3>Segurança de Dados</h3>
          <ul>
            <li>Criptografia de ponta a ponta</li>
            <li>Conformidade com LGPD/GDPR</li>
            <li>Auditorias trimestrais</li>
          </ul>
        </div>

        <div class="pillar-card">
          <div class="pillar-icon">💎</div>
          <h3>Qualidade Premium</h3>
          <ul>
            <li>Processo de desenvolvimento certificado</li>
            <li>Testes em 5 dispositivos diferentes</li>
            <li>Garantia de performance</li>
          </ul>
        </div>

        <div class="pillar-card">
          <div class="pillar-icon">🤝</div>
          <h3>Ética Digital</h3>
          <ul>
            <li>Zero trackers desnecessários</li>
            <li>Transparência total de coleta</li>
            <li>Open-source seletivo</li>
          </ul>
        </div>
      </div>
    </section>

    <!-- Tecnologias -->
    <section class="tech-section">
      <h2 class="section-title">Nossa Stack</h2>
      <div class="tech-grid">
        <div class="tech-card">
          <img src="../assets/tech-icons/android.png" alt="Android">
          <h4>Android Nativo</h4>
          <p>Kotlin e Jetpack Compose</p>
        </div>

        <div class="tech-card">
          <img src="../assets/tech-icons/apple.png" alt="iOS">
          <h4>iOS Nativo</h4>
          <p>Swift e SwiftUI</p>
        </div>

        <div class="tech-card">
          <img src="../assets/tech-icons/flutter.png" alt="Flutter">
          <h4>Cross-Platform</h4>
          <p>Flutter e React Native</p>
        </div>

        <div class="tech-card">
          <img src="../assets/tech-icons/security.png" alt="Segurança">
          <h4>Segurança</h4>
          <p>OWASP Top 10 Compliance</p>
        </div>
      </div>
    </section>

    <!-- CTA Contato -->
    <section class="contact-cta">
      <div class="cta-content">
        <h2>Pronto para Transformar sua Ideia?</h2>
        <p>Nossa equipe está pronta para elevar seu projeto ao próximo nível</p>
        <div class="contact-buttons">
          <a href="mailto:contato@aaapp.dev" class="contact-button email">contato@aaapp.dev</a>
          <a href="tel:+5511999999999" class="contact-button phone">+55 (11) 99999-9999</a>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: 'AboutPage'
}
</script>

<style scoped>
/* Estilos Base */
.about-page {
  max-width: 1280px;
  margin: 0 auto;
  padding: 2rem 1rem;
}

/* Timeline */
.timeline {
  position: relative;
  max-width: 800px;
  margin: 2rem auto;
}

.timeline::before {
  content: '';
  position: absolute;
  left: 50%;
  width: 2px;
  height: 100%;
  background: #4CAF50;
}

.timeline-item {
  display: flex;
  justify-content: space-between;
  margin-bottom: 4rem;
  position: relative;
}

.timeline-year {
  width: 120px;
  text-align: center;
  font-weight: bold;
  color: #4CAF50;
  font-size: 1.2rem;
}

.timeline-content {
  width: calc(50% - 60px);
  padding: 1.5rem;
  background: #F8F9FA;
  border-radius: 10px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.05);
}

/* Pilares */
.pillars-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 2rem;
  padding: 0 2rem;
}

.pillar-card {
  background: white;
  padding: 2rem;
  border-radius: 12px;
  border: 1px solid #E0E0E0;
}

.pillar-icon {
  font-size: 2.5rem;
  margin-bottom: 1rem;
}

/* Tecnologias */
.tech-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 2rem;
  padding: 2rem;
}

.tech-card {
  text-align: center;
  padding: 1.5rem;
  border: 1px solid #EEE;
  border-radius: 8px;
}

.tech-card img {
  height: 60px;
  margin-bottom: 1rem;
}

/* Contato */
.contact-cta {
  background: #4CAF50;
  color: white;
  padding: 4rem 2rem;
  margin-top: 4rem;
  text-align: center;
  border-radius: 15px;
}

.contact-buttons {
  display: flex;
  gap: 1rem;
  justify-content: center;
  margin-top: 1.5rem;
}

.contact-button {
  padding: 1rem 2rem;
  border-radius: 25px;
  text-decoration: none;
  font-weight: 500;
  transition: transform 0.3s ease;
}

.contact-button.email {
  background: white;
  color: #4CAF50;
}

.contact-button.phone {
  background: #388E3C;
  color: white;
}

/* Responsividade */
@media (max-width: 768px) {
  .timeline::before {
    left: 20px;
  }

  .timeline-item {
    flex-direction: column;
    margin-left: 40px;
  }

  .timeline-content {
    width: 100%;
    margin-top: 1rem;
  }

  .contact-buttons {
    flex-direction: column;
  }
}
</style>